import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAccountById, getAccountList, getGridDataByModuleKey } from '../../redux/selector';
import AccountForm from './accountForm';
import Notes from '../sharedChild/note/notes';
import Attachments from '../sharedChild/attachment/attachments';
import Email from '../sharedChild/email/emails';
import {
  fetchAttachmentsAndAppendToModule,
  fetchDataAndUpdateStore,
  fetchDetailAndAppendToModule,
  fetchEmailAndAppendToModule,
  fetchNotesAndAppendToModule,
  fetchTagsAndAppendToModule,
} from '../../redux/actions';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import Loader from '../../shared/component/Loader';
import Timeline from '../sharedChild/timeline';
import ChildDeal from '../sharedChild/childDeal';
import apiServices from '../../services/service';
import ChildContact from '../sharedChild/childContact';
import MemberAccount from './memberAccount';
import { accountInputData } from '../../shared/constants';
import { toast } from 'react-toastify';
import aiImage from '../../assets/img/crm_home/header/ai.png';
import Enrichment from '../leads/leadEnrichment';
import edit from '../../../src/assets/img/crm_home/header/edit.png';
import addNote from '../../../src/assets/img/crm_home/header/addNote.png';

const validationSchema = Yup.object().shape({
  businessType: Yup.string().required('Business Type is required'),
  industry: Yup.string().required('Industry is required'),
});

const ViewAccount = ({ handleFormSubmit }) => {
  const refs = {
    overview: useRef(null),
    attachments: useRef(null),
    opportunities: useRef(null),
    contacts: useRef(null),
    memberAccount: useRef(null),
    emails: useRef(null),
    timeline: useRef(null),
  };
  const [activeTab, setActiveTab] = useState('overview');
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(stateData, 'accountList');
  const [loading, setLoading] = useState(storeLoading);
  const [formData, setFormData] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({});
  const [accountByModule, setAccountByModule] = useState([]);
  const [contactByModule, setContactByModule] = useState([]);
  const [enrichedDataLoading, setEnrichedDataLoading] = useState(false);
  const [accountEnrichedData, setAccountEnrichedData] = useState();
  const [enrichedGenerateReportLoading, setEnrichedGenerateReportLoading] = useState(false);
  const [showPopupAccount, setShowPopupAccount] = useState(false);
  const [refreshView, setRefreshView] = useState(false);
  const accountList = useSelector(getAccountList);
  const gridData = useSelector(getGridDataByModuleKey('accountList'));

  let hasUpdateOpportunityPermission = true;
  let hasViewOpportunityPermission = true;
  let hasUpdateContactPermission = true;
  let hasViewContactPermission = true;
  let userUIControlPermissionOpportunity = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.opportunitymenu;
  let userUIControlPermissionContact = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.contactmenu;

  if (userUIControlPermissionOpportunity) {
    hasViewOpportunityPermission = userUIControlPermissionOpportunity?.opportunityviewscreen
      ? userUIControlPermissionOpportunity.opportunityviewscreen.canView
      : true;

    hasUpdateOpportunityPermission = userUIControlPermissionOpportunity?.opportunityupdatescreen
      ? userUIControlPermissionOpportunity.opportunityupdatescreen.canView
      : true;
  }
  if (userUIControlPermissionContact) {
    hasViewContactPermission = userUIControlPermissionContact?.contactviewscreen
      ? userUIControlPermissionContact.contactviewscreen.canView
      : true;

    hasUpdateContactPermission = userUIControlPermissionContact?.contactupdatescreen
      ? userUIControlPermissionContact.contactupdatescreen.canView
      : true;
  }

  const searchParams = new URLSearchParams(location.search);
  const accountID = searchParams.get('id');

  // const accountLocalData = useSelector((state) => {
  //   const accountId = location.state?.id || accountID;
  //   return getAccountById(state, accountId);
  // });
  const [accountLocalData, setAccountLocalData] = useState(location.state || {});

  const accountStoreData = useSelector((state) => {
    const accountId = location.state?.id || accountID; // Use the pre-fetched `leadID`
    return getAccountById(state, accountId);
  });

  useEffect(() => {
    setAccountLocalData((prev) => ({ ...prev, ...accountStoreData }));
  }, [accountStoreData]);

  const handleSubmit = async (formData) => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });
      handleFormSubmit(formData);
    } catch (error) {
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      console.error('Validation Error:', fieldErrors);
    }
  };

  const scrollToSection = (id) => {
    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Aligns the section close to the center
        inline: 'nearest',
      });

      // Slightly adjust the position to be a bit above the center
      setTimeout(() => {
        const offset = -50; // Adjust this value for how much higher you want
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300); // Adjust timeout if necessary for smoother behavior
    }
  };

  const handleOpenEditForm = (paramsValue) => {
    navigate('/accounts/editAccount', {
      state: { ...formData, from: "view" }
    });
  };

  // Function to open the fifth popup
  const openPopupAccount = () => {
    setShowPopupAccount(true);
  };

  const closePopupAccount = () => {
    setShowPopupAccount(false);
  };

  const handleClickDataEnrichment = (paramsValue) => {
    if (accountLocalData.website === '') {
      toast.error('Please fill in the Website field.', {
        position: 'top-right',
      });
      return;
    }
    setEnrichedDataLoading(true);

    const data = {
      CompanyName: `${accountLocalData.name}`,
      CompanyDomain: `${accountLocalData.website}`,
      EnrichmentType: 'accounts',
    };

    const fetchEnrichedData = () => {
      apiServices
        .getEnrichedData(data)
        .then((response) => {
          if (response.status === 200) {
            console.log('Data==>>', response.data);
            setAccountEnrichedData(response.data?.enriched_data);
            setEnrichedDataLoading(false);

            apiServices
              .updateEnrichedFlag(
                {
                  id: accountLocalData.id,
                },
                'Account'
              )
              .then((res) => {
                if (res.status === 200) {
                  openPopupAccount();
                  dispatch(
                    fetchDataAndUpdateStore({
                      key: 'accountList',
                      inputData: gridData?.inputPayload ? gridData.inputPayload : accountInputData,
                    })
                  );
                }
              })
              .catch((error) => {
                console.error('Error updating enriched flag:', error);
                toast.error('Failed to update enriched flag.', {
                  position: 'top-right',
                });
              });
          } else if (response.status === 202) {
            toast.info('Enrichment Initiated! Retrying in 2 minutes...', {
              position: 'top-right',
            });
            setTimeout(fetchEnrichedData, 120000); // Retry after 2 minutes
          }
        })
        .catch((error) => {
          console.error('Error while fetching enriched data:', error);

          // Safely extract error message from response
          const errorMsg = error?.response?.data?.error || 'An unexpected error occurred.';

          toast.error(errorMsg, {
            position: 'top-right',
          });

          setEnrichedDataLoading(false);
        });
    };

    fetchEnrichedData();
  };

  const handleClickReportGenerated = (flag = false) => {
    if (accountLocalData.website === '') {
      toast.error('Please fill in the Website field.', {
        position: 'top-right',
      });
      return;
    }
    setEnrichedGenerateReportLoading(true);

    const data = {
      CompanyName: `${accountLocalData.name}`,
      CompanyDomain: `${accountLocalData.website}`,
      EnrichmentType: 'accounts',
      Regenerate: flag,
    };

    const fetchGenerateReport = () => {
      apiServices
        .generateReport(data)
        .then((response) => {
          if (response.status === 200) {
            console.log('Data==>>', response.data);
            const htmlContent = response.data?.Report;
            const blob = new Blob([htmlContent], { type: 'text/html' });
            const url = URL.createObjectURL(blob);

            const newWindow = window.open(url, '_blank');

            setEnrichedGenerateReportLoading(false);

            apiServices
              .updateGenerateReportFlag(
                {
                  id: accountLocalData.id,
                },
                'Account'
              )
              .then((res) => {
                if (res.status === 200) {
                  dispatch(
                    fetchDataAndUpdateStore({
                      key: 'accountList',
                      inputData: gridData?.inputPayload ? gridData.inputPayload : accountInputData,
                    })
                  );
                }
              })
              .catch((error) => {
                console.error('Error updating generate report flag:', error);
                toast.error('Failed to update generate report flag.', {
                  position: 'top-right',
                });
              });
          } else if (response.status === 202) {
            toast.info('Generate Report Initiated! Retrying in 2 minutes...', {
              position: 'top-right',
            });
            setTimeout(fetchGenerateReport, 120000); // Retry after 2 minutes
          }
        })
        .catch((error) => {
          console.error('Error while fetching generate report data:', error);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setEnrichedGenerateReportLoading(false);
        });
    };

    fetchGenerateReport();
  };

  const handleUpdateForm = async (formData) => {
    setLoading(true);
    try {
      const response = await apiServices.updateAccountList(formData);
      if (response.status === 200) {
        await dispatch(
          fetchDataAndUpdateStore({
            key: 'accountList',
            inputData: gridData?.inputPayload ? gridData?.inputPayload : accountInputData,
          })
        );
        closePopupAccount();
        setRefreshView((prev) => !prev);
      } else {
        setLoading(false);
        const errorMessages = [];
        for (const key in response.errors) {
          if (response.errors.hasOwnProperty(key)) {
            const messages = response.errors[key];
            errorMessages.push(...messages);
          }
        }
        errorMessages.forEach((errorMessage) => {
          toast.error(errorMessage, { position: 'top-right' });
        });
      }
    } catch (error) {
      console.error('Error:', error, 'DataFormat:', formData);
      toast.error('An unexpected error occurred.', {
        position: 'top-right',
      });
      setLoading(false);
    }
  };

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useEffect(() => {
    if (accountLocalData?.id) {
      setLoading(true);
      const data = { moduleName: 'Account', id: accountLocalData?.id };
      apiServices
        .getOpportunityByModule(data)
        .then((response) => {
          if (response.status === 200) {
            const accountList = response.data;
            setAccountByModule(accountList);
            //storeLoading(false)
            setLoading(false);
          } else {
            console.error('Error fetching user timelog settings:', response?.status);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error('Error fetching user timelog settings:', error);
          setLoading(false);
        });
    }
  }, [accountLocalData?.id]);

  useEffect(() => {
    if (accountLocalData?.id) {
      setLoading(true);
      const data = { moduleName: 'Account', id: accountLocalData?.id };
      apiServices
        .getContactByModule(data)
        .then((response) => {
          if (response.status === 200) {
            const contactList = response.data;
            setContactByModule(contactList);
            setLoading(false);
          } else {
            console.error('Error fetching user timelog settings:', response?.status);
          }
        })
        .catch((error) => {
          console.error('Error fetching user timelog settings:', error);
        });
    }
  }, [accountLocalData?.id]);

  useEffect(() => {
    const observerOptions = {
      root: scrollContainerRef.current,
      rootMargin: '-300px 0px 0% 0px', // Adjusts the bottom margin to trigger when the section is halfway through the viewport
      threshold: 0,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveTab(sectionId);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each section
    Object.values(refs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    // Cleanup on unmount
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const accountId = location.state?.id || accountID;
    if (location.pathname.includes('viewAccount')) {
      setFormData({
        ...accountLocalData,
        type: 'view',
        from: 'view',
      });
    }
    if (accountId) {
      dispatch(
        fetchDetailAndAppendToModule({
          moduleName: 'Account',
          id: accountId,
          localDetail: location.state || null,
        })
      );
      dispatch(
        fetchNotesAndAppendToModule({
          moduleName: 'Account',
          id: accountId,
        })
      );
      dispatch(
        fetchAttachmentsAndAppendToModule({
          moduleName: 'Account',
          id: accountId,
        })
      );
      dispatch(
        fetchEmailAndAppendToModule({
          moduleName: 'Account',
          id: accountId,
        })
      );
      dispatch(
        fetchTagsAndAppendToModule({
          moduleName: 'Account',
          id: accountId,
        })
      );
    }
  }, [location, accountLocalData?.id, refreshView]);

  return (
    <>
      {loading && <Loader />}
      <div className="ViewLeadPageOuter">
        <div className="viewHeader">
          <HeaderProfileBlock localData={accountLocalData} moduleName={'Account'} View={true} />

          <div className="rightActionDskButton">
            <div className="rightAction">
              {accountLocalData?.isEnriched === true ? (
                <button className="btn btn-outline-primary" onClick={handleClickDataEnrichment}>
                  {enrichedDataLoading && (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  {enrichedDataLoading ? 'Loading...' : 'Refresh Enriched Data'}
                </button>
              ) : (
                <button
                  className="btn btn-outline-primary d-flex align-items-center"
                  onClick={handleClickDataEnrichment}
                  disabled={enrichedDataLoading} // Disable button when loading
                >
                  {enrichedDataLoading && (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}

                  {enrichedDataLoading ? (
                    'Loading...'
                  ) : (
                    <>
                      <img
                        src={aiImage}
                        alt="AI Icon"
                        className="me-2"
                        style={{ width: '16px', height: '16px' }}
                      />
                      Get Enriched Data{' '}
                    </>
                  )}
                </button>
              )}
              {accountLocalData?.isAccountReportGenerated === true ? (
                <div className="btn-group ms-3" id="timelogdropdown">
                  <button
                    type="button"
                    className="timelog-btn"
                    onClick={() => handleClickReportGenerated()}
                  >
                    View Report{' '}
                    {enrichedGenerateReportLoading && (
                      <span
                        className="spinner-border spinner-border-sm ms-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="visually-hidden">Toggle Dropdown</span>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li className="dropdown-item" onClick={() => handleClickReportGenerated(true)}>
                      Regenerate Report
                    </li>
                  </ul>
                </div>
              ) : (
                <button
                  className="btn btn-outline-primary d-flex align-items-center ms-3"
                  onClick={() => handleClickReportGenerated()}
                  disabled={enrichedGenerateReportLoading} // Disable button when loading
                >
                  {enrichedGenerateReportLoading && (
                    <>
                      {' '}
                      <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                    </>
                  )}
                  {enrichedGenerateReportLoading ? (
                    <span className="btnText">Generating...</span>
                  ) : (
                    <>
                      <img
                        src="../assets/images/report-file.svg"
                        alt="AI Icon"
                        className="me-2"
                        style={{ width: '10px', height: 'auto' }}
                      />
                      <span className="btnText">Generate Report </span>
                    </>
                  )}
                </button>
              )}
              <button
                className="btn btn-outline-primary ms-3"
                onClick={handleOpenEditForm}
                disabled={!formData}
              >
                <img
                  src={edit}
                  alt="Edit"
                  className="me-2"
                  style={{ width: '12px', height: '12px' }}
                />
                <span className="btnText">Edit</span>
              </button>
            </div>
            <div className="mob">
              <div className="adnoteMob ms-2">
                <button
                  className="btn btn-primary"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasExample"
                  aria-controls="offcanvasExample"
                >
                  <img
                    src={addNote}
                    alt="Add a Note"
                    className="me-2"
                    style={{ width: '12px', height: 'auto' }}
                  />
                  <span className="btnText">Add a Note</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="detailContainer">
          <div className="viewFormContainer">
            <div className="leftBlock">
              <ul>
                {Object.keys(refs).map((key) => (
                  <li
                    key={key}
                    onClick={() => scrollToSection(key)}
                    style={{ cursor: 'pointer' }}
                    className={activeTab === key ? 'leftbox activeList' : 'leftbox'}
                  >
                    <button onClick={() => setActiveTab(key)}>
                      {key.charAt(0).toUpperCase() + key.slice(1)}
                      {['openActivities', 'closedActivities', 'invitedMeetings'].includes(key) && (
                        <span style={{ fontSize: '7px', fontWeight: '600' }}> (Coming Soon)</span>
                      )}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rightBlock" id="detailPageRight">
              <div className="addlead_container">
                <Formik
                  initialValues={formData}
                  onSubmit={(values) => handleSubmit(values)}
                  validationSchema={validationSchema}
                >
                  <Form>
                    <div className="tab-content">
                      <div className="addleadcard1">
                        <div id="overview" className="scrollTo" ref={refs.overview}></div>
                        {formData && (
                          <AccountForm formData={formData} selectedOptions={selectedOptions} />
                        )}
                      </div>

                      <div id="attachments" className="scrollTo" ref={refs.attachments}></div>
                      <Attachments localData={accountLocalData} module={'Account'} />
                      {hasViewOpportunityPermission && (
                        <>
                          <div
                            id="opportunities"
                            className="scrollTo"
                            ref={refs.opportunities}
                          ></div>
                          <ChildDeal
                            localData={accountByModule}
                            module={'Account'}
                            hasUpdateOpportunityPermission={hasUpdateOpportunityPermission}
                          />
                        </>
                      )}
                      {hasViewContactPermission && (
                        <>
                          <div id="contacts" className="scrollTo" ref={refs.contacts}></div>
                          <ChildContact
                            localData={contactByModule}
                            module={'Account'}
                            hasUpdateContactPermission={hasUpdateContactPermission}
                          />
                        </>
                      )}
                      <div id="memberAccount" className="scrollTo" ref={refs.memberAccount}></div>
                      <MemberAccount localData={accountLocalData} module={'Account'} />

                      <div id="emails" className="scrollTo" ref={refs.emails}></div>
                      <Email localData={accountLocalData} />
                      <div id="timeline" className="scrollTo" ref={refs.timeline}></div>

                      <Timeline localData={accountLocalData} module={'Account'} />
                    </div>
                  </Form>
                </Formik>
              </div>
            </div>
          </div>
          <div className="viewFormNotesOuter">
            <div className="ViewFormNotesContainer">
              <Formik
                initialValues={formData}
                onSubmit={(values) => handleSubmit(values)}
                validationSchema={validationSchema}
              >
                <Form>
                  <div id="notes" className="scrollTo" ref={refs.notes}></div>
                  <Notes leadLocalData={accountLocalData} module={'Account'} />
                </Form>
              </Formik>
            </div>
          </div>
        </div>
        <div
          className="offcanvas addNoteMobBlock offcanvas-end"
          tabindex="-1"
          id="offcanvasExample"
          aria-labelledby="offcanvasExampleLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasExampleLabel">
              <img src="../assets/images/notesIcon.svg" alt="Note" width="16px" />
              Notes
            </h5>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <div className="ViewFormNotesContainer">
              <Formik initialValues={formData} validationSchema={validationSchema}>
                <Form id="viewForm">
                  <Notes leadLocalData={accountLocalData} module={'Account'}></Notes>
                </Form>
              </Formik>
            </div>
          </div>
        </div>
      </div>
      {showPopupAccount && (
        <Enrichment
          handleClose={closePopupAccount}
          localData={accountLocalData}
          enrichedData={accountEnrichedData}
          handleSave={handleUpdateForm}
          loading={loading}
        />
      )}
    </>
  );
};

export default ViewAccount;
